export default "__VITE_ASSET__BWRQVIeU__"